module.exports = __webpack_public_path__ + "img/1519352736.e964fd97.jpg";